export default {
  presenter: 'slimakova',
  title: 'Zdravá výživa pro každého',
  subtitle:
    'Jak se nejlépe stravovat pro prevenci nemocí, bezva postavu a dobrou náladu',
  text: `
Proč je třeba zdravě jíst a jak to v pohodě zvládat i bez počítání kalorií anebo jakýchkoliv jiných nepřirozených restrikcí? Co jsou ty nejkvalitnější potraviny? Jaká jsou nejlepší výživová doporučení?
Co vše potřebuje vaše dítě jíst a čemu by se mělo vyhýbat?
Jak vše zdravé zvládat v rámci rodiny, práce a volného času?
Podrobněji probereme dotazy, které Vás napadly během přednášky. Dozvíte se praktické tipy pro efektivní nákupy, budování zdravé domácnosti a tvorbu správných návyků.


Margit je v současnosti nejvýraznější česká specialistka na výživu a zdravotní prevenci. Zakladatelka 1. českého think tanku Globopol věnujícího se tématům zdravotní prevence a výživy.
Zpopularizovala u nás Zdravý talíř, který rychle nahrazuje zastaralou výživovou pyramidu. Vystudovala farmacii, dietologii v USA a četné certifikované kurzy. Pravidelně publikuje a přednáší, propaguje zdravou výživu na školách. Využívá osvědčené poznatky ze všech oblastí medicíny.
  `,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/p05_zdrava_strava.js